<div class="contenedorInt">
  <div class="contenedorIntHeader">
    <header class="FheaderInt" id="HconsultoriosPsicologicos">
      <div class="textHeader flx">
        <div class="dUno dmMedio"></div>
        <div class="dCincoM dtOcho dmOnce">
          <h1>CONSULTORIOS MÉDICOS DE ESPECIALIDADES</h1>
          <p>Fundación Best pone a su disposición consultorios de especialidad
            En ellos se brinda atención médica de Pediatría, Ginecología, entre otros.</p>
        </div>
        <div class="dCinco dtDos dmMedio"></div>
      </div>
    </header>
  </div>
  <div id="Fmap">
    <div class="FcfrCst">
      <div class="FcfrCstInt flx dSieteM dtDiez dmDoce">
        <div class="dDoce dmOnce FdirAzul">
          <div class="FformContacto dDoce">
            <form class="flx">
              <div class="cttInp dCuatro dtDoce dmDoce">
                <label>ESTADO*</label>
                <select 
                  name="estadoSeleccionado" 
                  [(ngModel)]="estadoSeleccionado" 
                  (change)="onEstadoChange()" 
                  class="form-control"
                >
                  <option [ngValue]="null" disabled>Seleccione Estado</option>
                  <option *ngFor="let estado of estados" [ngValue]="estado">
                    {{ estado.nombre }}
                  </option>
                </select>



              </div>

            </form>
            <!-- Mostrar múltiples sucursales -->
            <div *ngIf="estadoSeleccionado?.sucursales?.length > 0">
              <div class="dDiez dmDoce FtbRst flx mb-4" 
              *ngFor="let sucursal of estadoSeleccionado.sucursales">
                <p *ngIf="sucursal.unidad?.length > 0">Unidad: {{ sucursal.unidad}}</p>
                <!---<p *ngIf="sucursal.calle?.length > 0">Calle: {{ sucursal.calle }}</p>
                <p *ngIf="sucursal.numeroExterior?.length > 0">Número Exterior: {{ sucursal.numeroExterior }}</p>
                <p *ngIf="sucursal.numeroInterior?.length > 0">Número Interior: {{ sucursal.numeroInterior }}</p>
                <p *ngIf="sucursal.codigoPostal?.length > 0">Código Postal: {{ sucursal.codigoPostal }}</p>
                <p *ngIf="sucursal.telefono?.length > 0">Teléfono: {{ sucursal.telefono }}</p>-->

              </div>
            </div>

            <!-- Sin cobertura -->
           <div class="dDiez dmDoce FtbRst flx" *ngIf="dont">
              <p>Por el momento no tenemos cobertura en su zona</p>
            </div>

               <!---<button type="button" class="btn enviar"><a href="#">CONSULTAR COSTOS</a></button> -->
          </div>
        </div>
      </div>
    </div>
    <div class="espacioDefault"></div>
    <!--Aquí va el mapa-->

    <div class="Fmapa dNueve dtDiez dmOnce maxCnt">
      <div class="map-container">
        <div *ngIf="!geopotitonok" class="mapCover"></div>
        <div id="mapnu" class="map-card"></div>
      </div>
    </div>


  </div>
</div>
